import React, { useEffect, useState } from 'react'
import  styled  from 'styled-components'
import { popularProducts } from '../data'
import CategItems from './CategItems'
import Product from './Product'
import {mobile} from "../responses"
import axios from "axios"
import {Toaster,toast} from "react-hot-toast"

axios.defaults.baseURL="https://ecombackend-n9in.onrender.com/";

const Container=styled.div`
    padding:10px;
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:space-between;
    ${mobile({width:"100%"})};
`

const Products = ({cat,filters,sort}) => {
  // console.log({cat,filters,sort});

  
  const [products,setProducts]=useState([])
  const [filteredProducts,setFlteredProducts]=useState([])
  useEffect(()=>{
    const getProducts=async()=>{
      try {
        const {data,status}=await axios.get(!cat?`/api/products/`:`/api/products/?queryCategory=${cat}`)
        // console.log({data,status})
        setProducts(data.products);
        toast.success(`Checkout our latest products...`);
      } catch (error) { 
        console.log({error});
        toast.error("error");
      }
    }
    getProducts();
  },[cat])
  // console.log(Object.entries(filters));
  
  useEffect(()=>{
    cat && setFlteredProducts(
      products?.filter(item=>Object.entries(filters).every(([key,value])=>value==="ALL"||undefined?true:item[key].includes(value))
      )
    )
  },[products,cat,filters])

  useEffect(()=>{
    if(sort==="newest"){
  
      setFlteredProducts(pre=>[...pre].sort((a,b)=>{
        console.log(pre);

        const aTime=new Date(a.updatedAt)
        const bTime=new Date(b.updatedAt)
        console.log(aTime.getTime(),bTime.getTime());
        
        return aTime.getTime()-bTime.getTime()}))
    }
    else if(sort==="asc"){
      setFlteredProducts(pre=>[...pre].sort((a,b)=>a.price-b.price))
    }
    else {
      setFlteredProducts(pre=>[...pre].sort((a,b)=>b.price-a.price))
    }
  },[sort])
  return (
    <Container>
      
      {
      cat? filteredProducts.map(item=>{
            return (
                <Product key={item._id} item={item}/>
            )
        }) : products.map(item=>{
          return (
              <Product key={item._id} item={item}/>
          )
      }) 
      }
    </Container>
  )
}

export default Products
